import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface BreadcrumbItem {
    title: string;
    disabled?: boolean;
    to?: string;
}

export const usePageHeaderStore = defineStore('pageHeader', () => {
    const breadcrumbs = ref<BreadcrumbItem[]>([]);
    // Optional Osmos help article key for the current page. When null, the
    // breadcrumb help (`?`) trigger is hidden; pages opt in by passing a key
    // to usePageBreadcrumbs().
    const helpKey = ref<string | null>(null);
    // Name of the route whose view actually wrote the two refs above. Pages that
    // never call usePageBreadcrumbs (the legal documents, which mount a Fondation
    // component, and any future route that forgets) used to display whatever the
    // previously visited page had left behind. PageHeader compares this against
    // the current route and ignores a trail that belongs to another page (#715).
    const owner = ref<string | null>(null);
    return { breadcrumbs, helpKey, owner };
});
